// Generated by ReScript, PLEASE EDIT WITH CARE

import * as OrderStage from "../../../ticket-dashboard/app/tickets/entities/OrderStage.bs.js";
import * as TicketRaisedBy from "../../../ticket-dashboard/app/tickets/entities/TicketRaisedBy.bs.js";
import * as DateTime$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as CreateTicketApiModel from "../api-model/CreateTicketApiModel.bs.js";

function encode(payload) {
  return {
          caller_number: payload.caller_number,
          msisdn: payload.msisdn,
          crn: payload.crn,
          location: payload.location,
          order_stage: OrderStage.toString(payload.order_stage),
          raised_by: TicketRaisedBy.toString(payload.raised_by),
          issue: payload.issue,
          ticket_action: payload.ticket_action,
          issue_comments: payload.issue_comments,
          action_comments: payload.action_comments,
          start_ts: DateTime$Catalyst.toString(undefined, payload.start_ts)
        };
}

function execute(payload) {
  return CreateTicketApiModel.t_encode(encode(payload));
}

export {
  encode ,
  execute ,
  
}
/* DateTime-Catalyst Not a pure module */
